import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d5a94a5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "recipe-container-comments",
  class: "recipe-container-comments"
}
const _hoisted_2 = { class: "recipe-container-comments-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Comments", -1))
const _hoisted_4 = { class: "add-comment-view" }
const _hoisted_5 = { class: "container-post-comment-button" }
const _hoisted_6 = { class: "add-comment-view" }
const _hoisted_7 = { class: "container-post-comment-button" }
const _hoisted_8 = {
  key: 1,
  class: "recipe-comments"
}
const _hoisted_9 = { class: "recipe-per-comment" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuillEditor = _resolveComponent("QuillEditor")!
  const _component_LoaderCircle = _resolveComponent("LoaderCircle")!
  const _component_CommentView = _resolveComponent("CommentView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        (_ctx.state === 'none')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "button-add",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state = 'add'))
            }, " + "))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "button-minimize",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.state = 'none'))
            }, "-"))
      ])
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_QuillEditor, {
              placeholder: "New Comment",
              onTextChange: _ctx.updateNewComment,
              required: ""
            }, null, 8, ["onTextChange"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "button-save-green",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addComment && _ctx.addComment(...args)))
              }, " Post comment ")
            ])
          ], 512), [
            [_vShow, _ctx.state === 'add']
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            _createVNode(_component_QuillEditor, {
              onTextChange: _ctx.updateNewComment,
              required: ""
            }, null, 8, ["onTextChange"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                class: "button-save-green",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateExistingComment && _ctx.updateExistingComment(...args)))
              }, " Update ")
            ])
          ], 512), [
            [_vShow, _ctx.state === 'edit']
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderCircle, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recipe.comments, (comment, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_CommentView, {
                  comment: comment,
                  onOnEditClicked: _ctx.onEditClicked,
                  onOnDeleteClicked: _ctx.onDeleteClicked
                }, null, 8, ["comment", "onOnEditClicked", "onOnDeleteClicked"])
              ])
            ]))
          }), 128))
        ]))
  ]))
}